(function(){
  var closeTimer;

  Pegasus.PreviewControlModeView = Em.View.extend({
    type: Em.required(),
    templateName: 'controls/preview/mode',
    classNames: ['preview-control-mode-wrapper'],
    rotatedBinding: 'controller.rotated',
    canToggle: function(){
      return this.get('type') === 'phone' ||
        this.get('type') === 'tablet';
    }.property('type'),
    isActive: function(){
      return this.get('controller.activeType') === this.get('type');
    }.property('type', 'controller.activeType'),
    click: function(e){
      e.stopPropagation();
      // If we already clicked close ignore all actions
      if ( closeTimer ) {
        closeTimer = null;
        return;
      }

      if( this.get('isActive') ){
        this.toggleProperty('rotated');
        return;
      }

      if ( this.get('type') === 'exit' ) {
        $('.preview-iframe-container').css('opacity', 0);
        Em.run.cancel(closeTimer);
        closeTimer = Em.run.later( this, 'set', 'controller.activeType', this.get('type'), 400 );
      } else {
        this.set('controller.activeType', this.get('type'));
      }
    },
    resetState: function(){
      closeTimer = null;
      this.set('rotated', false);
    },
    willDestroyElement: function(){
      this.resetState();
      this._super();
    }
  });
})();

Pegasus.PreviewControlsView = Em.ContainerView.extend({
  classNames: ['preview-control-panel'],
  childViews: ['desktop', 'phone', 'tablet', 'exit'],
  exit: Pegasus.PreviewControlModeView.extend({
    type: 'exit'
  }),
  desktop: Pegasus.PreviewControlModeView.extend({
    type: 'desktop'
  }),
  phone: Pegasus.PreviewControlModeView.extend({
    type: 'phone'
  }),
  tablet: Pegasus.PreviewControlModeView.extend({
    type: 'tablet'
  })
});
